<template>
  <span
    class="relative inline-flex align-middle"
    @mouseenter="show = true"
    @mouseleave="show = false"
  >
    <button
      type="button"
      class="text-gray-400 hover:text-[#00225E] focus:text-[#00225E] focus:outline-none"
      :aria-label="title ? `Info: ${title}` : 'More information'"
      @focus="show = true"
      @blur="show = false"
      @click.prevent
    >
      <svg class="w-4 h-4" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
        <path fill-rule="evenodd" d="M18 10A8 8 0 112 10a8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd" />
      </svg>
    </button>

    <transition
      enter-active-class="transition ease-out duration-100"
      enter-from-class="opacity-0 translate-y-1"
      enter-to-class="opacity-100 translate-y-0"
      leave-active-class="transition ease-in duration-75"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <span
        v-if="show"
        role="tooltip"
        class="absolute z-30 top-6 right-0 w-64 rounded-lg bg-[#0b0b0b] text-white text-xs leading-relaxed p-3 shadow-xl"
      >
        <span v-if="title" class="block font-semibold mb-1">{{ title }}</span>
        <span class="block text-gray-200 font-normal whitespace-normal"><slot>{{ text }}</slot></span>
      </span>
    </transition>
  </span>
</template>

<script>
import { ref } from "vue";

// Small accessible info popover: an ⓘ trigger that reveals an explanation on
// hover or keyboard focus. No external dependency.
export default {
  props: {
    title: { type: String, default: "" },
    text: { type: String, default: "" },
  },
  setup() {
    const show = ref(false);
    return { show };
  },
};
</script>
